<template>
  <div class="faq__item-container">
    <AccordionRoot class="faq print:hidden" :class="class" collapsible type="single" :default-value="defaultValue">
      <AccordionItem :value="value" class="faq__item">
        <AccordionHeader as="div" class="h3 faq__header">
          <AccordionTrigger class="faq__trigger w-full flex justify-between items-center py-5 px-4 md:py-5">
            <div class="faq__question text-medium-bold text-left">{{ faq.question }}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" class="faq__trigger-icon">
              <path
                d="M8.88379 20.5303C8.78615 20.6279 8.6279 20.6279 8.53027 20.5303L8.17676 20.1768C8.07913 20.0792 8.07916 19.9209 8.17676 19.8233L15.8232 12.1768C15.9209 12.0792 16.0791 12.0792 16.1768 12.1768L23.8232 19.8233C23.9209 19.9209 23.9209 20.0792 23.8232 20.1768L23.4697 20.5303C23.3721 20.6279 23.2139 20.6279 23.1162 20.5303L16 13.4141L8.88379 20.5303Z"
                fill="#042942"
                stroke="#042942"
              />
            </svg>
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent class="faq__answer text-regular-normal px-4 overflow-hidden" :class="{ 'faq__answer--initialized': initialized }">
          <div class="faq__answer-content pb-5 lg:pb-6 inner-html-text" v-html="faq.answer" />
        </AccordionContent>
      </AccordionItem>
    </AccordionRoot>

    <div :class="class" class="faq__item-container-print print:block hidden">
      <div class="faq__question text-medium-bold text-left py-5 px-4 md:py-5">{{ faq.question }}</div>
      <div class="faq__answer text-regular-normal inner-html-text pb-5 lg:pb-6 px-4 overflow-hidden" v-html="faq.answer" />
    </div>

  </div>
</template>

<script setup lang="ts">
  import type { FAQ } from '~/types/strapi';
  import { AccordionContent, AccordionHeader, AccordionItem, AccordionRoot, AccordionTrigger } from 'reka-ui';

  const value = useId();

  const props = defineProps<{
    faq: FAQ;
    class?: string | string[] | Record<string, boolean>;
  }>();

  const defaultValue = ref<string | string[] | undefined>(!!props.faq.open ? value : undefined);
  const initialized = ref(false);

  onMounted(() => {
    initialized.value = true;
  });
</script>
<style lang="scss" scoped>
  .faq {
    &__item {
      .faq__trigger-icon {
        @apply transition-transform duration-300 ease-in-out;
        transform: rotate(180deg);
      }

      &[data-state='open'] {
        .faq__trigger-icon {
          transform: rotate(0deg);
        }
      }
    }
    &__answer.faq__answer--initialized {
      @apply general-accordion-toggle-animation;
    }
  }
</style>
